<template>
    <div id="login">

        <!-- RECOVER -->
        <template v-if="recover.active">

            <template v-if="recover.success">

                <span class="title">¡Contraseña enviada!</span>
                <span class="subtitle">Te hemos enviado un email para que puedas modificar tu contraseña</span>

                <p class="alert">
                    ¿Todabía no has recibido el email? Contáctanos en <a href="mailto:support@sigarus.com">support@sigarus.com</a>
                </p>

            </template>
            <template v-else>

                <span class="title">Recuperar contraseña</span>
                <span class="subtitle">Escribe tu dirección de email</span>

                <el-alert
                    v-if="error"
                    :closable="false"
                    :center="true"
                    title="Ha ocurrido un error"
                    type="error">
                </el-alert>

                <el-form 
                    ref="form_recover" 
                    label-position="top" 
                    :rules="recover.rules" 
                    :model="recover.form" 
                    label-width="120px" 
                    v-loading="loading">

                    <el-form-item prop="email">
                        <el-input 
                            v-model="recover.form.email" 
                            placeholder="Email"  
                            @keyup.enter.native="onRecover"></el-input>
                    </el-form-item>
                    
                    <el-form-item>
                        <el-button 
                            type="primary" 
                            @click="onRecover">Restablecer contraseña</el-button>
                    </el-form-item>

                    <p class="recover" @click="recover.active = false">Iniciar sesión</p>
                </el-form>

            </template>
            
        </template>

        <!-- LOGIN -->
        <template v-else>
            <span class="title">Iniciar sesión</span>

            <el-alert
                v-if="error"
                :closable="false"
                :center="true"
                title="Usuario o contraseña incorrecto"
                type="error">
            </el-alert>

            <el-form 
                ref="form_login" 
                label-position="top" 
                :rules="login.rules" 
                :model="login.form" 
                label-width="120px" 
                v-loading="loading">

                <el-form-item prop="user">
                    <el-input 
                        v-model="login.form.user" 
                        placeholder="Usuario"  
                        @keyup.enter.native="onLogin"></el-input>
                </el-form-item>

                <el-form-item prop="password">
                    <el-input 
                        v-model="login.form.password" 
                        placeholder="Contraseña" 
                        show-password  
                        @keyup.enter.native="onLogin"></el-input>
                </el-form-item>

                <el-form-item class="form-item-remember">
                    <el-checkbox 
                        v-model="login.remember">Recordar contraseña</el-checkbox>
                </el-form-item>
                
                <el-form-item>
                    <el-button type="primary" @click="onLogin">Iniciar sesión</el-button>
                </el-form-item>

                <p class="recover" @click="recover.active = true">Recuperar contraseña</p>
            </el-form>
        </template>

    </div>
</template>

<script>
	import {
        login,
        recover,
        setToken 
    } from '@/helpers/api'

	export default {
        name: 'ModalLogin',
		data () {
			return {
                loading: false,
                error: false,

                // LOGIN
                login: {
                    form: {
                        user: '',
                        password: ''
                    },
                    rules: {
                        password: [
                            { required: true, message: 'Introduce una contraseña', trigger: 'blur' }
                        ],
                        user: [
                            { required: true, message: 'Introduce un usuario', trigger: 'blur' }
                        ]
                    },
                    remember: false, // Recordar contraseña    
                },
                
                // RECOVER
                recover: {
                    active: false,
                    success: false,
                    form: {
                        email: ''
                    },
                    rules: {
                        email: [
                            { required: true, message: 'Introduce un email', trigger: 'blur' }
                        ]
                    }
                }
			}
        },
        watch: {
            'recover.active'() {
                if (this.$refs.form_login) this.$refs.form_login.resetFields();
                if (this.$refs.form_recover) this.$refs.form_recover.resetFields();
            }
        },
		methods: {

            async onLogin() {
                
                this.error = false
                let _self = this

                await this.$refs['form_login'].validate(async (valid) => {
                    if (valid) {

                        _self.loading = true

                        try {

                            let resp = await login(_self.login.form);

                            let token = resp.data.token.replace('Bearer ','')
                            _self.setAccessToken(token)

                            _self.$emit('success', token)

                        } catch(err) {
                            _self.error = true
                        }
                    
                        _self.loading = false
                        
                    } else {
                        return false;
                    }
                });
            },
            setAccessToken(token) {
                localStorage.removeItem('accessToken')
				localStorage.setItem('accessToken', token)
                setToken(token)
                this.setRemember()
            },
            setRemember() {
                if (this.remember) {
                    this.$cookies.set("remember", this.form)
                }
            },
            async onRecover() {

                this.error = false
                let _self = this

                await this.$refs['form_recover'].validate(async (valid) => {
                    if (valid) {

                        _self.loading = true

                        try {

                            let resp = await recover(_self.recover.form);
                            console.log('resp recover: ',resp)

                        } catch(err) {
                            _self.error = true
                        }
                    
                        _self.loading = false
                        
                    } else {
                        return false;
                    }
                });
            }
		}
	}
</script>

<style lang="scss">
#login {
    span {
        &.title {
            display: block;
            text-align: center;
            font-size: 1.5rem;
            padding: 40px 0px 10px 0px;
            font-weight: 400;
            color:#4a596a;
        }
        &.subtitle {
            display: block;
            text-align: center;
            color: #929292;
            margin: 0px 0px 1em 0px;
            font-size: 0.9rem;
        }
    }
    p.alert {
        text-align: center;
        padding: 50px 15px;
        font-size: 0.8rem;
        color: #929292;
    }
    .el-alert {
        margin: 0px 25px;
        width: auto;
    }
    form {
        width: -webkit-fill-available;
        padding: 25px 25px 10px 25px;

        button {
            width: 100%;
        }

        .recover {
            text-align: center;
            color: #929292;
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        }

        .form-item-remember {
            .el-form-item__content {
                line-height: 20px!important;
            }
        }
    }
    
}
</style>
